var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgDownload = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6665 4.33335C11.6665 3.96516 11.368 3.66669 10.9998 3.66669C10.6316 3.66669 10.3332 3.96516 10.3332 4.33335V12.0572L7.47124 9.19524C7.21089 8.93489 6.78878 8.93489 6.52843 9.19524C6.26808 9.45559 6.26808 9.8777 6.52843 10.1381L10.5284 14.1381L10.9998 14.6095L11.4712 14.1381L15.4712 10.1381C15.7316 9.8777 15.7316 9.45559 15.4712 9.19524C15.2109 8.93489 14.7888 8.93489 14.5284 9.19524L11.6665 12.0572V4.33335ZM4.33317 12.3334C4.70136 12.3334 4.99984 12.6318 4.99984 13V14.3334C4.99984 15.4379 5.89527 16.3334 6.99984 16.3334H14.9998C16.1044 16.3334 16.9998 15.4379 16.9998 14.3334V13C16.9998 12.6318 17.2983 12.3334 17.6665 12.3334C18.0347 12.3334 18.3332 12.6318 18.3332 13V14.3334C18.3332 16.1743 16.8408 17.6667 14.9998 17.6667H6.99984C5.15889 17.6667 3.6665 16.1743 3.6665 14.3334V13C3.6665 12.6318 3.96498 12.3334 4.33317 12.3334Z"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgDownload);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/download.fcb92de77548c8a3cb975db6e4ab9df7.svg";